import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";

const MyAccountSetting = () => {
  const navigate = useNavigate();
  const [loaderStatus, setLoaderStatus] = useState(true);

  /* ======================
     LOGOUT (FINAL)
  ====================== */
 
const handleLogout = () => {
  const confirmLogout = window.confirm(
    "Are you sure you want to logout?"
  );

  if (!confirmLogout) return;

  localStorage.clear();
  window.location.href = "/MyAccountSignIn";
};

  /* ======================
     AUTH CHECK (FIXED)
  ====================== */
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token) {
      navigate("/MyAccountSignIn", { replace: true });
      return;
    }

    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div>
      <ScrollToTop />

      <section>
        <div className="container">
          <div className="row">

            {/* MOBILE HEADER */}
            <div className="col-12 d-md-none mb-3 d-flex justify-content-between align-items-center">
              <h3 className="fs-5 mb-0">Account Settings</h3>
              <button
                className="btn btn-outline-secondary"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasAccount"
              >
                ☰
              </button>
            </div>

            {/* SIDEBAR (DESKTOP) */}
            <div className="col-lg-3 col-md-4 d-none d-md-block border-end">
              <ul className="nav flex-column nav-pills p-4 gap-2">
                <li className="nav-item">
                  <Link className="nav-link" to="/my-orders">
                    🛍 Your Orders
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link active" to="/MyAccountSetting">
                    ⚙️ Settings
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/MyAccountAddress">
                    📍 Address
                  </Link>
                </li>

                <li className="nav-item">
                  <Link className="nav-link" to="/MyAccountPayment">
                    💳 Payment Method
                  </Link>
                </li>

                <hr />

                <li className="nav-item">
                  <button
                    type="button"
                    className="nav-link text-danger btn btn-link text-start"
                    onClick={handleLogout}
                  >
                    🚪 Logout
                  </button>
                </li>
              </ul>
            </div>

            {/* MAIN CONTENT */}
            <div className="col-lg-9 col-md-8">
              {loaderStatus ? (
                <div className="text-center my-5">
                  <MagnifyingGlass height="80" width="80" color="#0aad0a" />
                </div>
              ) : (
                <div className="p-4">
                  <h2 className="mb-4">Account Settings</h2>

                  {/* ACCOUNT DETAILS */}
                  <div className="mb-5">
                    <h5>Account Details</h5>
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="mb-3">
                        <label className="form-label">Name</label>
                        <input
                          className="form-control"
                          placeholder="Your name"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Email</label>
                        <input
                          className="form-control"
                          placeholder="Email"
                        />
                      </div>

                      <div className="mb-3">
                        <label className="form-label">Phone</label>
                        <input
                          className="form-control"
                          placeholder="Phone"
                        />
                      </div>

                      <button className="btn btn-primary" disabled>
                        Save Details (Coming Soon)
                      </button>
                    </form>
                  </div>

                  <hr />

                  {/* PASSWORD */}
                  <div className="mb-5">
                    <h5>Password</h5>
                    <form onSubmit={(e) => e.preventDefault()}>
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <input
                            type="password"
                            className="form-control"
                            placeholder="New Password"
                          />
                        </div>

                        <div className="col-md-6 mb-3">
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Current Password"
                          />
                        </div>
                      </div>

                      <button className="btn btn-primary" disabled>
                        Save Password (Coming Soon)
                      </button>
                    </form>
                  </div>

                  <hr />

                  {/* DELETE ACCOUNT */}
                  <div>
                    <h5 className="text-danger">Delete Account</h5>
                    <p className="text-muted">
                      This action is irreversible.
                    </p>
                    <button className="btn btn-outline-danger" disabled>
                      Delete Account (Coming Soon)
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* OFFCANVAS (MOBILE) */}
      <div className="offcanvas offcanvas-start" id="offcanvasAccount">
        <div className="offcanvas-header">
          <h5>My Account</h5>
          <button className="btn-close" data-bs-dismiss="offcanvas" />
        </div>

        <div className="offcanvas-body">
          <ul className="nav flex-column gap-2">
            <li>
              <Link to="/MyAccountOrder" className="nav-link">
                Your Orders
              </Link>
            </li>

            <li>
              <Link
                to="/MyAccountSetting"
                className="nav-link active"
              >
                Settings
              </Link>
            </li>

            <li>
              <Link to="/MyAccountAddress" className="nav-link">
                Address
              </Link>
            </li>

            <li>
              <Link to="/MyAccountPayment" className="nav-link">
                Payment Method
              </Link>
            </li>

            <li>
              
              <button
  type="button"
  className="dropdown-item text-danger"
  onClick={() => {
    const ok = window.confirm("Are you sure you want to logout?");
    if (!ok) return;

    // 🔔 SHOW TOAST
    const toastEl = document.getElementById("logoutToast");
    if (toastEl && window.bootstrap) {
      const toast = new window.bootstrap.Toast(toastEl, {
        delay: 1500,
      });
      toast.show();
    }

    // ⏳ thoda delay so toast dikh jaaye
    setTimeout(() => {
      localStorage.clear();
      window.location.href = "/MyAccountSignIn";
    }, 1200);
  }}
>
  Logout
</button>

            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MyAccountSetting;
